import Model from './model'

export default class CustomerContactSubmission extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/customer-contact-submission'
    }
}
